import { PostAdd } from '@mui/icons-material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Box, CircularProgress, MenuItem, Popover } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ScheduledReportActionPopup = ({
  popoverElement,
  handleCloseMenu,
  handleEditScheduledReport,
  handleDeleteReport,
  loading,
}) => {
  const { t: translate } = useTranslation();

  return (
    <Popover
      open={Boolean(popoverElement)}
      anchorEl={popoverElement}
      onClose={handleCloseMenu}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: { p: 1, width: 'auto', '& .MuiMenuItem-root': { px: 1, typography: 'body2', borderRadius: 0.75 } },
      }}
    >
      {' '}
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
          <CircularProgress size={24} />
        </Box>
      ) : (
        <>
          <MenuItem sx={{ color: 'info.main' }} onClick={handleEditScheduledReport}>
            <PostAdd sx={{ mr: 1 }} /> {translate('scheduled_reports.edit_scheduled_report')}
          </MenuItem>
          <MenuItem sx={{ color: 'error.main' }} onClick={handleDeleteReport}>
            <DeleteForeverIcon sx={{ mr: 1 }} /> {translate('scheduled_reports.delete_scheduled_report')}
          </MenuItem>
        </>
      )}
    </Popover>
  );
};
export default ScheduledReportActionPopup;
